import { useState } from "react";
import { motion } from "framer-motion";
import { useAuthStore } from "../store/authStore";
import CreditsForm from "./CreditsForm"; // Import the CreditsForm component
import { Link } from "react-router-dom"; // For navigation links
import { FaUser } from "react-icons/fa"; // Profile icon from react-icons
// import PaymentHistoryPage from "./PaymentHistoryPage"; // Import the PaymentHistoryModal

const NavbarPage = () => {
  const { user, logout, credits } = useAuthStore();
  const [showCreditsForm, setShowCreditsForm] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
//   const [showPaymentHistory, setShowPaymentHistory] = useState(false);

  const handleBuyCreditsClick = () => {
    setShowCreditsForm(true);
  };

  const closeCreditsForm = () => {
    setShowCreditsForm(false);
  };

  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };

//   const openPaymentHistory = () => {
//     setShowPaymentHistory(true);
//     setShowProfileMenu(false);
//   };

//   const closePaymentHistory = () => {
//     setShowPaymentHistory(false);
//   };

  return (
    <motion.nav
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-gray-900 bg-opacity-100 backdrop-filter backdrop-blur-lg shadow-2xl border-b border-gray-800 fixed top-0 left-0 right-0 z-40 bg-white"
    >
      <div className="max-w mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img
              src="/images/WriteZenLogo.jpeg"
              alt="WriteZEN Logo"
              className="h-10 w-auto"
            />
          </div>
          <div className="flex items-center space-x-4">
            <p className="text-black hidden md:block">Credits: {credits}</p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleBuyCreditsClick}
              className="py-2 px-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold rounded-lg shadow-lg hover:from-blue-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Buy Credits
            </motion.button>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={toggleProfileMenu}
              className="relative cursor-pointer"
            >
              <FaUser className="text-blue-500 text-2xl" />
              {showProfileMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-lg shadow-lg">
                  <div className="px-4 py-2 text-white font-semibold">Hi, {user.name}!</div>
                  <Link
                    to="/"
                    className="block px-4 py-2 text-gray-300 hover:bg-gray-700"
                  >
                    Home Page
                  </Link>
                  <Link
                    to="/payment-history" // Link to the payment history page
                    state={{ from: 'dashboard' }}
                    className="block px-4 py-2 text-gray-300 hover:bg-gray-700"
                  >
                    Payment History
                  </Link>
                  <button
                    onClick={logout}
                    className="w-full text-left px-4 py-2 text-red-500 hover:bg-gray-700"
                  >
                    Logout
                  </button>
                </div>
              )}
            </motion.div>
          </div>
        </div>
      </div>

      {showCreditsForm && <CreditsForm onClose={closeCreditsForm} />}

      {/* {showPaymentHistory && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-3xl w-full max-h-[90%] overflow-auto">
            <PaymentHistoryPage onClose={closePaymentHistory} />
          </div>
        </div>
      )} */}
    </motion.nav>
  );
};

export default NavbarPage;
